import { getStaticPath } from '@/utils/getStaticPath'

export const yandexMapsUrl = `https://api-maps.yandex.ru/2.1/?apikey=${process.env.YANDEX_API_KEY}&lang=ru-RU`
export const TINY_MCE_HOSTING_CLIENT_PATH = getStaticPath('scripts/tinymce/tinymce.min.js')
export const TINY_MCE_RU_LANGUAGE_PATH = getStaticPath('scripts/tinymceAddons/language/ru.js')
